import React, { createContext, useState, useEffect, useRef } from 'react'

const OkeMonitorContext = createContext()

const OkeMonitorProvider = (props) => {
  let { sendMessageToWebView, frameType } = props
  let entitiesRef = useRef({})
  let [entities, setEntities] = useState({})
  let [entityState, setEntityState] = useState({})
  let entityStateRef = useRef({})
  let entityTimeoutCountRef = useRef({})
  let timeoutRef = useRef(null)

  const checkEntityState = async () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    sendMessageToWebView({
      action: 'monitorState',
      data: { }
    }).then((res) => {
      let newState = {}
      for(let ent of res.data?.entities || []) {
        if(!ent?.status?.alive) {
          entityTimeoutCountRef.current[ent.id] = (entityTimeoutCountRef.current[ent.id] || 0) + 1
          if(entityTimeoutCountRef.current[ent.id] > 3) {
            newState[ent.id] = { alive: false }
          }
        } else {
          entityTimeoutCountRef.current[ent.id] = 0
          newState[ent.id] = { alive: true }
        }
      }
      if(JSON.stringify(newState) !== JSON.stringify(entityStateRef.current)) {
        entityStateRef.current = newState
        setEntityState(newState)
      }
      timeoutRef.current = setTimeout(() => {
        checkEntityState()
      }, 1000)
    }).catch((e) => {
      console.log('monitorState error', e)
    })
  }

  const setEntity = (entity) => {
    setEntities({ ...entitiesRef.current, [entity.id]: entity })
  }

  const startMonitor = () => {
    if(entitiesRef.current == null) return
    sendMessageToWebView({
      action: 'monitorStart',
      data: { entities: Object.values(entitiesRef.current) }
    }).then((res) => {
      //console.log('monitorStart success', res)
      checkEntityState()
    }).catch((e) => {
      console.log('monitorStart error', e)
    })
  }

  useEffect(() => {
    if(entities && frameType === 'okeElectron') {
      if (JSON.stringify(entitiesRef.current) !== JSON.stringify(entities)) {
        entitiesRef.current = entities
        setTimeout(() => {
          startMonitor()
        }, 1000)
      }
    }
  }, [entities, frameType])

  return (
    <OkeMonitorContext.Provider
      value={{
        setEntity,
        entityState,
        entities
      }}
    >
      {props.children}
    </OkeMonitorContext.Provider>
  )
}

export { OkeMonitorContext, OkeMonitorProvider }
